export const SHOP = '/shop' as const
export const PRODUCTS = '/products' as const
export const CATEGORIES = '/categories' as const
export const COLORS = '/colors' as const
export const SIZES = '/sizes' as const
export const MATERIALS = '/materials' as const
export const ADMIN_ORDER = '/admin-orders' as const
export const STUDENT_ORDER = '/student-orders' as const
